// extracted by mini-css-extract-plugin
module.exports = {"did":"FunFact_did__7fegG","fact":"FunFact_fact__sQimG","threex":"FunFact_threex__1Z3T6","line":"FunFact_line__oQQHf"};